import { Link } from "react-router-dom";

const educationData = [
  {
    id: "msmba",
    degree: "MSM/MBA — Wilmington University, 2020 & 2021",
    field: "Management Information Systems / Web Development & Design",
    image: "/images/wilmu-logo.png",
  },
  {
    id: "msmmba",
    degree: "MSM/MBA — Wilmington University, 2014 & 2017",
    field: "Healthcare Administration / Management",
    image: "/images/wilmu-logo.png",
  },
  {
    id: "bs",
    degree: "BS — Wilmington University, 2011",
    field: "Allied Health Education",
    image: "/images/wilmu-logo.png",
  },
  {
    id: "as",
    degree: "AS — Delaware Technical and Community College, 2009",
    field: "Respiratory Care Therapy",
    image: "/images/DTCC.jpg",
  },
];

const Education = () => (
  <div>
    <div className="hero-wrap" style={{ marginBottom: "3rem" }}>
      <img src="/images/education-banner.png" alt="Education Banner" />
      <div className="hero-overlay" />
      <div className="hero-content">
        <div className="hero-title">My Quest for Knowledge</div>
      </div>
    </div>

    <div className="container pb-5">
      <h2 className="section-title">Education</h2>
      {educationData.map((item) => (
        <div
          className="edu-card d-flex align-items-center gap-3 p-3 mb-4"
          key={item.id}
        >
          <img src={item.image} alt="School" className="edu-logo" />
          <div className="flex-grow-1 py-1">
            <div className="edu-degree">{item.degree}</div>
            <div className="edu-field">{item.field}</div>
            <Link to={`/education/${item.id}`} className="edu-link">
              More Information →
            </Link>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default Education;
